import { AliasGroupContext } from '@src/contextProviders/AliasGroup';
import { useContext } from 'react';

const useAliasGroupContext = () => {
  const aliasGroup = useContext(AliasGroupContext);
  if (!aliasGroup) {
    throw new Error(
      'useAliasGroup must be used within an AliasGroupContextProvider',
    );
  }
  return aliasGroup;
};

export default useAliasGroupContext;
